/**
 * A note made from a lead form keeps one "Question: answer" per line (Meta
 * lead import and CSV import). Split it so the answer can stand out.
 * Returns null when the note is ordinary text.
 */
export type FormAnswer = { question: string; answer: string };

const LINE = /^(.{3,160}?\?|[^:\n]{3,80}):\s+(.+)$/;

export const parseFormAnswers = (text: string | null | undefined) => {
  const lines = (text ?? "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
  if (lines.length === 0) return null;
  const answers: FormAnswer[] = [];
  for (const line of lines) {
    const match = line.match(LINE);
    if (!match) return null;
    answers.push({ question: match[1].replace(/\s+/g, " "), answer: match[2] });
  }
  return answers;
};
